// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__FlX8h"};